import axios from 'axios';
import { loginreq, req } from './axiosFun';
// 登录接口 
export const login = (params) => { return loginreq("post", "/api/front/user/login", params) };
// 获取图片验证码
export const getimgVerifyCode = () => { return req("get", '/api/front/resource/imgVerifyCode') }


// 退出接口
export const loginout = () => { return axios.delete("/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 用户管理 
 **/
// 用户管理-获取用户列表
export const userList = (params) => { return req("get", "/api/front/user/userList", {}, params) };

// 余额充值
export const accountRecharge = (params) => { return req("put", "/api/front/sum/up", {}, params) };

// 

/**
* 接口设置
 **/
// 获取接口信息
export const getApiInfo = (params) => { return req("get", "/api/front/config/getConfig?name=" + params) };
// 获取接口列表
export const getApiInfoList = () => { return req("get", "/api/front/config/getConfigList") };
// 修改接口
export const updateApi = (params) => { return req("post", "/api/front/config/setConfig", params) };


// 首页统计

// 积分池 用户量 待处理反馈 订单总量

export const getTotalapi = (params) => { return req("get", "/api/front/count/getTotal") };




// WEBPACK FOOTER //
// ./src/api/userMG.js